export default __webpack_public_path__ + "static/media/carbon_policy.c7488aeb.svg";